import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Renderer2, inject } from '@angular/core';

import { UiHelpersService } from '../../services';
import { ExportHelpers } from '../../services/export-helper/export-helper.service';

enum RecordTypes {
  FORMATTED_JSON = 'formattedJson',
  PLAIN = 'plain',
}

@Component({
  selector: 'phoenix-json-record',
  template: `
    <div aria-label="json-record">
      <div
        class="p-2 flex items-center justify-center theme-bg-1 rounded-md w-full max-h-[45px]"
        name="json-content"
      >
        <div class="w-40">JSON Record</div>

        <div class="w-full flex flex-row justify-end items-center">
          <div class="p-2">
            <mat-button-toggle-group
              name="fontStyle"
              name="jsonRecordButtonToggle"
              #viewer="matButtonToggleGroup"
              aria-label="Font Style"
              [hideSingleSelectionIndicator]="true"
              [(ngModel)]="selectedType"
              (change)="defaultOption(viewer.value)"
            >
              <mat-button-toggle
                matTooltip="Formatted view"
                value="formattedJson"
              >
                <mat-icon> data_object </mat-icon></mat-button-toggle
              >
              <mat-button-toggle matTooltip="Plain view" value="plain">
                <mat-icon> format_align_left </mat-icon></mat-button-toggle
              >
            </mat-button-toggle-group>
          </div>
          @if (!hideDownload) {
            <button
              mat-icon-button
              aria-label="json-download-button"
              matTooltip="Download"
              color="primary"
              class="material-icons-outlined"
              (click)="downloadJson()"
            >
              cloud_download
            </button>
          }
          <button
            mat-icon-button
            aria-label="json-copy-button"
            matTooltip="Copy"
            (click)="showSnackbar()"
            [cdkCopyToClipboard]="record | json"
          >
            <mat-icon class="material-icons-outlined"> content_copy </mat-icon>
          </button>
        </div>
      </div>
      <div class="px-4">
        @if (selectedType === recordTypes.FORMATTED_JSON) {
          <phoenix-json-viewer [json]="record"></phoenix-json-viewer>
        } @else if (selectedType === recordTypes.PLAIN) {
          <phoenix-json-highlight [data]="record"></phoenix-json-highlight>
        }
      </div>
    </div>
  `,
  standalone: false,
})
export class JsonRecordComponent implements OnInit {
  @Input() record: any;
  @Input() hideDownload = false;

  readonly renderer = inject(Renderer2);
  readonly _uiHelper = inject(UiHelpersService);
  readonly datePipe = inject(DatePipe);
  recordTypes = RecordTypes;
  selectedType: RecordTypes = RecordTypes.FORMATTED_JSON;

  ngOnInit(): void {
    const defaultData = localStorage.getItem(`defaultJsonRecordViewer`);
    this.selectedType =
      (defaultData as RecordTypes) || RecordTypes.FORMATTED_JSON;
  }

  downloadJson() {
    const date = this.datePipe.transform(new Date(), 'yyyyMMddHHmmss');

    const fileName = `jsonfile_${date}`;
    ExportHelpers.downloadJSON(this.renderer, this.record, fileName);
  }

  showSnackbar(): void {
    this._uiHelper.informationSnackbar('Copied to clipboard!', 3000);
  }

  defaultOption(value: string) {
    localStorage.setItem('defaultJsonRecordViewer', value);
  }
}
